export const RoutePaths = {
    masterPlan: "masterPlan",
    multiplePlot: "multiplePlotList",
    map: 'map'
}